import Model from "./model";

const MONITORING_EVENT_TYPE_CD = {
  DEVICE: "0",
  BATTERY: "1",
  CONTACT: "2",
};

const NOTIFICATION_STATUS_CD = {
  ON: "1",
  OFF: "0",
};

/* eslint-disable no-unused-expressions */
class MonitoringEventRule extends Model {
  constructor(monitoringTargetId, monitoringEventRuleId = null) {
    super();

    this._monitoringTargetId = monitoringTargetId;
    this._monitoringEventRuleId = monitoringEventRuleId;

    this._monitoringEventTypeCd;
    this._nextCheckpoint;
    this._statusCd;
    this._config;
    this._organizationId;
    this._projectId;
  }

  get monitoringTargetId() {
    return this._monitoringTargetId;
  }

  set monitoringTargetId(value) {
    this._monitoringTargetId = value;
  }

  get monitoringEventRuleId() {
    return this._monitoringEventRuleId;
  }

  set monitoringEventRuleId(value) {
    this._monitoringEventRuleId = value;
  }

  get monitoringEventTypeCd() {
    return this._monitoringEventTypeCd;
  }

  set monitoringEventTypeCd(value) {
    this._monitoringEventTypeCd = value;
  }

  get nextCheckpoint() {
    return this._nextCheckpoint;
  }

  set nextCheckpoint(value) {
    this._nextCheckpoint = value;
  }

  get statusCd() {
    return this._statusCd;
  }

  set statusCd(value) {
    this._statusCd = value;
  }

  get config() {
    return this._config;
  }

  set config(obj) {
    this._config = obj;
  }

  get organizationId() {
    return this._organizationId;
  }

  set organizationId(value) {
    this._organizationId = value;
  }

  get projectId() {
    return this._projectId;
  }

  set projectId(value) {
    this._projectId = value;
  }

  isRegisterd() {
    return !!this.subscriptionId;
  }

  json() {
    return {
      ...super.json(),
      monitoringTargetId: this.monitoringTargetId,
      monitoringEventRuleId: this.monitoringEventRuleId,
      monitoringEventTypeCd: this.monitoringEventTypeCd,
      nextCheckpoint: this._extCheckpoint,
      statusCd: this.statusCd,
      organizationId: this.organizationId,
      projectId: this.projectId,
    };
  }

  copy() {
    const monitoringEventRule
      = new MonitoringEventRule(this.monitoringTargetId, this.monitoringEventRuleId);
    monitoringEventRule.copyProperties(this);
    return monitoringEventRule;
  }

  copyProperties(monitoringEventRule) {
    super.copyProperties(monitoringEventRule);

    this.monitoringEventTypeCd = monitoringEventRule.monitoringEventTypeCd;
    this.nextCheckpoint = monitoringEventRule.nextCheckpoint;
    this.statusCd = monitoringEventRule.statusCd;
    // this.config = monitoringEventRule.config.copy();
    this.organizationId = monitoringEventRule.organizationId;
    this.projectId = monitoringEventRule.projectId;
  }

  getApiRequestJson() {
    const requestJosn = super.getApiRequestJson();

    Object.assign(requestJosn, {
      monitoring_event_type_cd: this.monitoringEventTypeCd,
      next_checkpoint: this.nextCheckpoint,
      status_cd: this.statusCd,
      // config: {},
      organization_id: this.organizationId,
      project_id: this.projectId,
    });
    return requestJosn;
  }

  setApiResponseJosn(item) {
    super.setApiResponseJosn(item);

    this.monitoringEventTypeCd = item.monitoring_event_type_cd;
    this.nextCheckpoint = item.next_checkpoint;
    this.statusCd = item.status_cd;
    // this.config = null;
    this.organizationId = item.organization_id;
    this.projectId = item.project_id;
  }
}
/* eslint-enable */

class EventNotification {
  /* eslint-disable no-unused-expressions */
  constructor() {
    this._statusCd = NOTIFICATION_STATUS_CD.ON;
    this._title = "";
  }
  /* eslint-enable */

  get statusCd() {
    return this._statusCd;
  }

  set statusCd(value) {
    this._statusCd = value;
  }

  get title() {
    return this._title;
  }

  set title(value) {
    this._title = value;
  }

  json() {
    return {
      statusCd: this.statusCd,
      title: this.title,
    };
  }

  getApiRequestJson() {
    return {
      status_cd: this.statusCd,
      title: this.title,
    };
  }

  copy() {
    const eventNotification = new EventNotification();
    eventNotification.statusCd = this.statusCd;
    eventNotification.title = this.title;
    return eventNotification;
  }
}

export {
  MONITORING_EVENT_TYPE_CD,
  NOTIFICATION_STATUS_CD,
  EventNotification,
  MonitoringEventRule,
};
